import { useState, useEffect } from 'react'

const HomeLockModal = ({ open, onUnlock }) => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isUnlocked, setIsUnlocked] = useState(false)

  useEffect(() => {
    const unlocked = localStorage.getItem('enerqiq_unlocked')
    if (unlocked === '1') {
      setIsUnlocked(true)
      onUnlock()
    }
  }, [onUnlock])

  if (!open || isUnlocked) return null

  const handleSubmit = (e) => {
    e.preventDefault()

    if (password.trim() === 'EnerqiQ2026.') {
      setError('')
      localStorage.setItem('enerqiq_unlocked', '1')
      setIsUnlocked(true)
      onUnlock()
      return
    }

    setError('Nesprávne heslo')
  }

  return (
    <div style={overlay}>
      <form style={modal} onSubmit={handleSubmit}>
        <h3 style={{ margin: 0 }}>Vstup do EnerqiQ Net</h3>

        <div style={{ fontSize: 14, opacity: 0.8 }}>
          Pre odomknutie zadaj heslo
        </div>

        <input
          type="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
            if (error) setError('')
          }}
          autoFocus
          style={input}
          placeholder="Heslo"
        />

        {error && (
          <div style={{ color: '#ff6b6b', fontSize: 13 }}>
            {error}
          </div>
        )}

        <button type="submit" style={button}>
          Odomknúť
        </button>
      </form>
    </div>
  )
}

export default HomeLockModal

const overlay = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(6, 13, 16, 0.55)',
  backdropFilter: 'blur(6px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 6000
}

const modal = {
  width: 'min(92vw, 380px)',
  background: '#102326',
  color: '#d9ffe4',
  border: '1px solid #107c6b',
  borderRadius: 12,
  padding: 20,
  boxShadow: '0 20px 40px rgba(0,0,0,0.45)',
  display: 'flex',
  flexDirection: 'column',
  gap: 12
}

const input = {
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: 8,
  border: '1px solid #1f8d7b',
  padding: '10px 12px',
  fontSize: 16,
  outline: 'none'
}

const button = {
  border: 'none',
  borderRadius: 8,
  background: '#107c6b',
  color: '#fff',
  padding: '10px 14px',
  fontWeight: 700,
  cursor: 'pointer'
}